import script from "./inventorySuppliers.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventorySuppliers.vue?vue&type=script&setup=true&lang=ts"

import "./inventorySuppliers.vue?vue&type=style&index=0&id=05d53635&lang=scss"

const __exports__ = script;

export default __exports__